function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M59.9 38.3l.9 1.4h-7.9l-6.1-9.6-1.9 2v7.6h-6.6l.1-32.4h6.5v15.9l7.3-7.9h8.6l-9.4 10.1zM187.6 1v43h2V1z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1.543)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M70.1 13.8v24.4H63.6V13.8h6.5zm.4-6.4c0 2-1.6 3.6-3.6 3.6s-3.7-1.6-3.7-3.6 1.7-3.7 3.7-3.7c2 .1 3.6 1.7 3.6 3.7zM97.6 26.3v11.8h-6.4V26.3c0-2.9-1.5-5.8-4.9-5.8-3.2 0-5.8 2.6-5.8 5.8v11.8h-6.4V13.7h6.4v1.9c1.7-.9 3.7-1.5 5.8-1.5 6.5 0 11.3 5.2 11.3 12.2M106.2 25.5l10.5-3.1c-1.9-5-11.5-2.1-10.5 3.1zm18.1 4.4c-2.6 6-8.2 10-14.8 8.5-5.9-1.3-10.3-7-9.7-13.4 1.4-15.2 22.6-14.6 24.1.4-5.4 1.7-10.9 3.2-16.3 4.8 3.1 3.7 8.7 2.2 10.6-2l6.1 1.7zM144.6 26.5c0-3.2-2.6-5.8-5.8-5.8-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8m0-10.8l.1-10h6.4v32.6h-6.4v-1.1c-1.7 1-3.7 1.5-5.8 1.5-6.7 0-12.2-5.5-12.2-12.2 0-6.7 5.5-12.2 12.2-12.2 2 0 4 .5 5.7 1.4M154.4 26.5V14.2h6.4v12.3c0 2.9 1.5 5.8 4.9 5.8 3.2 0 5.8-2.6 5.8-5.8V14.2h6.4v24.5h-6.4v-1.4c-1.7.9-3.7 1.5-5.8 1.5-6.5-.1-11.3-5.2-11.3-12.3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#DA4D7A",
  d: "M28.7 38.2c0-8.3-7-15-15-15v15h15z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__a",
  filterUnits: "userSpaceOnUse",
  x: 0.1,
  y: 23.2,
  width: 11.2,
  height: 15
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 0.1,
  y: 23.2,
  width: 11.2,
  height: 15,
  id: "kinedu-educators-es_svg__b"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__b)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M.1 38.1h11.2V23.2H.1z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__c",
  filterUnits: "userSpaceOnUse",
  x: 13.7,
  y: 8.4,
  width: 12.6,
  height: 12.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 13.7,
  y: 8.4,
  width: 12.6,
  height: 12.6,
  id: "kinedu-educators-es_svg__d"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__d)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F9BA48",
  d: "M20 8.4c3.5 0 6.3 2.8 6.3 6.3S23.5 21 20 21s-6.3-2.8-6.3-6.3 2.8-6.3 6.3-6.3"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__e",
  filterUnits: "userSpaceOnUse",
  x: 0.1,
  y: 5.8,
  width: 11.2,
  height: 15
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 0.1,
  y: 5.8,
  width: 11.2,
  height: 15,
  id: "kinedu-educators-es_svg__f"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__f)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#45C94E",
  d: "M.1 20.8h11.2v-15H.1z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__g",
  filterUnits: "userSpaceOnUse",
  x: 199.2,
  y: 17.6,
  width: 19.1,
  height: 20.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 199.2,
  y: 17.6,
  width: 19.1,
  height: 20.6,
  id: "kinedu-educators-es_svg__h"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__h)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M208.9 20.2c-4.2 0-6.3 3.5-6.4 6.5h12.9c-.1-2.9-2.1-6.5-6.5-6.5m-9.7 7.7c0-5.7 4.1-10.3 9.7-10.3 5.9 0 9.4 4.6 9.4 10.5v.8h-15.8c.2 3.7 2.8 6.8 7 6.8 2.3 0 4.5-.9 6.1-2.5l1.5 2c-2 1.9-4.6 3-7.8 3-5.9 0-10.1-4.2-10.1-10.3"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__i",
  filterUnits: "userSpaceOnUse",
  x: 221.3,
  y: 10.7,
  width: 18.4,
  height: 27.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 221.3,
  y: 10.7,
  width: 18.4,
  height: 27.6,
  id: "kinedu-educators-es_svg__j"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__i)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__j)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M236.6 32.4v-8.8c-1.1-1.7-3.4-3.2-5.8-3.2-4 0-6.3 3.2-6.3 7.6 0 4.3 2.4 7.5 6.3 7.5 2.4 0 4.8-1.4 5.8-3.1zm0 5.3v-2.9c-1.5 2-3.9 3.4-6.6 3.4-5.1 0-8.7-3.9-8.7-10.3 0-6.3 3.6-10.3 8.7-10.3 2.6 0 5 1.3 6.6 3.5V10.7h3v27.1h-3z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__k",
  filterUnits: "userSpaceOnUse",
  x: 244.9,
  y: 18.1,
  width: 16.3,
  height: 20.1
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 244.9,
  y: 18.1,
  width: 16.3,
  height: 20.1,
  id: "kinedu-educators-es_svg__l"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__k)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__l)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M258.2 37.7V35c-1.5 1.7-4.1 3.2-7 3.2-4.1 0-6.3-2-6.3-6.3V18.1h3V31c0 3.5 1.7 4.5 4.4 4.5 2.4 0 4.6-1.4 5.8-3V18.1h3v19.6h-2.9z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__m",
  filterUnits: "userSpaceOnUse",
  x: 265.3,
  y: 17.6,
  width: 17,
  height: 20.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 265.3,
  y: 17.6,
  width: 17,
  height: 20.6,
  id: "kinedu-educators-es_svg__n"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__m)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__n)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M265.3 27.9c0-5.8 3.9-10.3 9.8-10.3 3.6 0 5.7 1.5 7.2 3.4l-2 1.8c-1.3-1.8-3-2.5-5-2.5-4.1 0-6.8 3.2-6.8 7.5s2.6 7.6 6.8 7.6c2 0 3.7-.8 5-2.6l2 1.9c-1.5 1.9-3.6 3.4-7.2 3.4-5.8.1-9.8-4.4-9.8-10.2"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__o",
  filterUnits: "userSpaceOnUse",
  x: 284.7,
  y: 17.6,
  width: 16.4,
  height: 20.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 284.7,
  y: 17.6,
  width: 16.4,
  height: 20.6,
  id: "kinedu-educators-es_svg__p"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__o)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__p)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M298.1 33.6v-3.7c-1.2-1.6-3.2-2.4-5.4-2.4-2.9 0-4.9 1.8-4.9 4.3s2 4.3 4.9 4.3c2.1-.1 4.2-.9 5.4-2.5zm0 4.1v-2.2c-1.6 1.8-3.9 2.7-6.5 2.7-3.3 0-6.8-2.2-6.8-6.5 0-4.4 3.5-6.5 6.8-6.5 2.7 0 4.9.9 6.5 2.6v-3.5c0-2.6-2.1-4.1-5-4.1-2.4 0-4.3.8-6 2.7l-1.4-2.1c2.1-2.2 4.6-3.2 7.8-3.2 4.2 0 7.6 1.9 7.6 6.6v13.5h-3z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__q",
  filterUnits: "userSpaceOnUse",
  x: 305.3,
  y: 10.7,
  width: 18.4,
  height: 27.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 305.3,
  y: 10.7,
  width: 18.4,
  height: 27.6,
  id: "kinedu-educators-es_svg__r"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__q)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__r)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M320.6 32.4v-8.8c-1.1-1.7-3.4-3.2-5.8-3.2-4 0-6.3 3.2-6.3 7.6 0 4.3 2.4 7.5 6.3 7.5 2.4 0 4.8-1.4 5.8-3.1zm0 5.3v-2.9c-1.5 2-3.9 3.4-6.6 3.4-5.1 0-8.7-3.9-8.7-10.3 0-6.3 3.6-10.3 8.7-10.3 2.6 0 5 1.3 6.6 3.5V10.7h3v27.1h-3z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__s",
  filterUnits: "userSpaceOnUse",
  x: 327.8,
  y: 17.6,
  width: 19.4,
  height: 20.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 327.8,
  y: 17.6,
  width: 19.4,
  height: 20.6,
  id: "kinedu-educators-es_svg__t"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__s)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__t)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M344 27.9c0-4-2.3-7.5-6.5-7.5S331 24 331 27.9c0 4 2.3 7.6 6.5 7.6s6.5-3.6 6.5-7.6m-16.2 0c0-5.7 3.7-10.3 9.7-10.3s9.7 4.6 9.7 10.3-3.7 10.3-9.7 10.3-9.7-4.6-9.7-10.3"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__u",
  filterUnits: "userSpaceOnUse",
  x: 351.3,
  y: 17.7,
  width: 9.6,
  height: 20.1
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 351.3,
  y: 17.7,
  width: 9.6,
  height: 20.1,
  id: "kinedu-educators-es_svg__v"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__u)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__v)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M351.3 37.7V18.1h3v3.1c1.6-2 3.9-3.6 6.5-3.6v3.1c-.4 0-.7-.1-1.2-.1-1.9 0-4.5 1.5-5.4 3.1v13.9h-2.9z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__w",
  filterUnits: "userSpaceOnUse",
  x: 362.8,
  y: 17.6,
  width: 19.1,
  height: 20.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 362.8,
  y: 17.6,
  width: 19.1,
  height: 20.6,
  id: "kinedu-educators-es_svg__x"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__w)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__x)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M372.4 20.2c-4.2 0-6.3 3.5-6.4 6.5h12.9c-.1-2.9-2-6.5-6.5-6.5m-9.6 7.7c0-5.7 4.1-10.3 9.7-10.3 5.9 0 9.4 4.6 9.4 10.5v.8H366c.2 3.7 2.8 6.8 7 6.8 2.3 0 4.5-.9 6.1-2.5l1.5 2c-2 1.9-4.6 3-7.8 3-5.8 0-10-4.2-10-10.3"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "kinedu-educators-es_svg__y",
  filterUnits: "userSpaceOnUse",
  x: 384.3,
  y: 17.6,
  width: 15.6,
  height: 20.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 384.3,
  y: 17.6,
  width: 15.6,
  height: 20.6,
  id: "kinedu-educators-es_svg__z"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#kinedu-educators-es_svg__y)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FFF",
  d: "M.1 42.5h399.8V-.6H.1z"
}))), /*#__PURE__*/React.createElement("path", {
  mask: "url(#kinedu-educators-es_svg__z)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#0086D8",
  d: "M384.3 35.1l1.5-2.2c1.3 1.5 3.8 2.8 6.5 2.8 3 0 4.7-1.4 4.7-3.4 0-4.7-12.1-1.8-12.1-9.1 0-3.1 2.6-5.6 7.3-5.6 3.4 0 5.7 1.3 7.3 2.8l-1.4 2.1c-1.2-1.4-3.3-2.5-5.8-2.5-2.7 0-4.3 1.3-4.3 3.1 0 4.3 12.1 1.5 12.1 9.1 0 3.3-2.6 5.9-7.7 5.9-3.4.1-6.1-.9-8.1-3"
}));

function SvgKineduEducatorsEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 45",
    enableBackground: "new 0 0 400 45"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/kinedu-educators-es.8a47c8dc.svg";
export { SvgKineduEducatorsEs as ReactComponent };